import * as React from 'react';
require('./style.css');

interface IProps {
	text: string;
}

/**
 *
 * @param props
 */
export const Label = (props: IProps) => {
	return <label className="portalLabel">{props.text}</label>;
};
